module.exports = __webpack_public_path__ + "static/media/AugustaMargaretRiverTimes-devicecomp-min@2x.5658f368.webp";